import React,{useState} from "react";
import Title from "../Wrappers/Title";

import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Divider } from "@material-ui/core";
import useStyles from "./styles";

const calculate = (data) => {
    var breakC = 0;
    var durationC = 0;
    return new Promise((resolve, reject) => {
        if (Array.isArray(data) && data.length) {
            data.forEach((element, index, array) => {
                for (let val in element) {
                    if (val === "breakCount") {
                        breakC += parseInt(element.breakCount);
                    } else if (val === "duration") {
                        durationC += parseInt(element.duration);
                    }
                }
            })
            let res = {
                "count": breakC,
                "duration": durationC
            };
            resolve(res);

        } else {
            reject(0);
        }
    })
}
function convertSeconds(seconds) {
    var convert = function(x) { return (x < 10) ? "0"+x : x; }
    return convert(parseInt(seconds / (60*60))) + ":" +
           convert(parseInt(seconds / 60 % 60)) + ":" +
           convert(seconds % 60)
  }
function ShowBreakStatistics(props) {
	var classes = useStyles();
    
    const [totalCount, setTotalCount] = useState(0);
	const [totalDuration, setTotalDuration] = useState(0);
    if(props.agentBreaks.length>0){
        calculate(props.agentBreaks).then((sum)=>{
            const { count, duration } = sum;
            setTotalCount(count);
            setTotalDuration(duration);
        }).catch(e=>console.log(e));
    }
    const breaks=props.agentBreaks;
    

	return (
		<React.Fragment>
			<Title>Break Statistics</Title>
			<Divider />
			<Table margin="0px" padding="none">
				<TableHead className={classes.Table}>
					<TableRow className={classes.TableCell}>
						<TableCell>Break Type</TableCell>
						<TableCell>Break Count</TableCell>
						<TableCell>Duration</TableCell>
					</TableRow>
				</TableHead>
				<TableBody className={classes.TableBody}>
					{breaks.length
						? breaks.map((row) => (
								<TableRow className={classes.TableCellBody} key={row.breakType}>
									<TableCell className={classes.TableBodycell}>{row.breakType}</TableCell>
									<TableCell className={classes.TableBodycell}>{row.breakCount}</TableCell>
									<TableCell className={classes.TableBodycell}>{convertSeconds(row.duration)}</TableCell>
								</TableRow>
						  ))
						: null}
				</TableBody>
				<TableFooter className={classes.TableFooter}>
					<TableRow className={classes.TableCell}>
						<TableCell className={classes.TableFootercell}>Total</TableCell>
						<TableCell className={classes.TableFootercell}>{totalCount}</TableCell>
						<TableCell className={classes.TableFootercell}>{convertSeconds(totalDuration)}</TableCell>
					</TableRow>
				</TableFooter>
			</Table>
		</React.Fragment>
	);
}


export default ShowBreakStatistics;
